interface GradientHeaderProps {
  size?: "sm" | "md" | "lg";
  /** @deprecated kept for call-site compatibility; the editorial header has no gradient */
  gradient?: string;
  children: React.ReactNode;
}

const sizeClasses = {
  sm: "pb-5 pt-5",
  md: "pb-6 pt-6",
  lg: "pb-7 pt-6",
};

/**
 * Editorial page header — "Minted in Daylight" (DESIGN.md).
 * Light ground, hairline rule below, left-aligned content. The card is the
 * only dark object in the app; headers stay on paper.
 */
export const GradientHeader = ({ size = "md", children }: GradientHeaderProps) => (
  <div className={`relative bg-ground ${sizeClasses[size]} px-5 border-b border-hairline`}>
    {children}
  </div>
);
